export const name = 'membership-type-toggle';

const inputSelectorString = '[name*="select_up_or_downgrade[membershipType]';

export default class MembershipTypeToggle {
    get name() {
        return name;
    }

    constructor(node) {
        this.node = node;

        this.cacheSelectors();
        this.setupEventListeners();

        const activeInput = this.getCurrentSelectedInput();

        if (activeInput) {
            this.renderReceiptAreaForValue(activeInput.value);
        }
    }

    cacheSelectors() {
        this.inputs = this.node.querySelectorAll(inputSelectorString);
        this.receipts = this.node.querySelectorAll('[data-membership-receipt]');
    }

    setupEventListeners() {
        this.subscribe(`dom:${inputSelectorString}:change`, e => this.handleMembershipTypeChange(e));
    }

    getCurrentSelectedInput() {
        if (!this.inputs) {
            return false;
        }

        return Array.from(this.inputs).find(el => el.checked);
    }

    renderReceiptAreaForValue(value) {
        value = value.toLowerCase();

        this.receipts.forEach(el => {
            el.hidden = el.dataset.membershipReceipt !== value;
        });
    }

    handleMembershipTypeChange(e) {
        const selectedValue = e.target.value;

        this.renderReceiptAreaForValue(selectedValue);
    }
}
